import React, { useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
// import { deleteAndRestoreProduct } from "../reduxSaga/actions";
import { Alert, Snackbar } from "@mui/material";
import RestoreFromTrashRoundedIcon from "@material-ui/icons/RestoreFromTrashRounded";
import SocieteAndUserService from "../../../services/societeAndUser";
import UtilsUrl from "../../../utils/UtilsUrl";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";

const ClientGroupeSocieteTable = ({ listClients, typeClient }) => {
  const navigate = useNavigate();

  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [clients, setClients] = useState(listClients);
  // const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);

  const { SearchBar } = Search;
  const MyExportCSV = (props) => {
    const handleClick = () => {
      props.onExport();
    };
    return (
      <div>
        <button className="btn btn-dark" onClick={handleClick}>
          <i class="fas fa-download"></i> Télécharger CSV
        </button>
      </div>
    );
  };

  const onDeleteSociete = (isDeleted, idSociete, index, state) => {
    SocieteAndUserService.deleteSocieteGroupe(localStorage.getItem("GroupeId"),idSociete)
      .then((response) => {
        if (Object.keys(response.data)[0] === "success") {
          window.location.href = "/tiers";
        } else if (Object.keys(response.data)[0] === "error") {
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connection");
      });

    console.log("index", index);
  };

  function buttonDeleteFormatter(cell, row) {
    if (row.isDeleted === 0) {
      return (
        <span>
          <button
            className="btn btn-danger"
            onClick={(e) => {
              onDeleteSociete(row.isDeleted, row.id, "allSuplliers");
              setOpenInfoAlert(true);

              setInfoAlertText("Element supprimé avec succée ");

              setClients(clients.filter((dept) => dept.id !== cell));
            }}
          >
            <h6>
              <small>
                {" "}
                <i class="fas fa-trash"></i>
              </small>
            </h6>
          </button>
        </span>
      );
    } 
  }
//   function buttonClientFournisseurFormatter(cell, row) {
//     console.log("row", row);
//     if (tag === "FOURNISSEUR") {
//       if (row.isDeleted === 0) {
//         return (
//           <span>
//             <button
//               key={row.id}
//               className="btn btn-danger"
//               onClick={(e) => {
//                 onChangeSociete(row.id, tag);
//                 // setOpenInfoAlert(true);
//                 // setInfoAlertText("Fournisseur modifié avec succée ");

//                 // setClients(clients.filter((dept) => dept.id !== cell));
//               }}
//             >
//               <h6>
//                 <small>CLIENT</small>
//               </h6>
//             </button>
//           </span>
//         );
//       } else if (row.isDeleted === 1) {
//         return (
//           <span>
//             {/* <button
//             className="btn btn-info"
//             onClick={(e) => {
//               let deletedAndRestoreModel;

//               deletedAndRestoreModel = {
//                 idProduct: cell,
//                 isDeleted: 0,
//               };

//               //   dispatch(deleteAndRestoreProduct(deletedAndRestoreModel));
//               onDeleteOrRestaureSociete(row.isDeleted, row.id, "allSuplliers");

//               setInfoAlertText("Element restauré avec succée ");
//               setOpenInfoAlert(true);
//               setClients(clients.filter((dept) => dept.id !== cell));
//             }}
//           >
//             <h6>
//               <small>
//                  CLIENT
//               </small>
//             </h6>
//           </button> */}
//           </span>
//         );
//       }
//     } else if (tag === "CLIENT") {
//       if (row.isDeleted === 0) {
//         return (
//           <span>
//             <button
//               key={row.id}
//               className="btn btn-danger"
//               onClick={(e) => {
//                 onChangeSociete(row.id, tag);
//                 // setOpenInfoAlert(true);

//                 // setInfoAlertText("Client modifié avec succée ");

//                 // setClients(clients.filter((dept) => dept.id !== cell));
//               }}
//             >
//               <h6>
//                 <small>FOURNISSEUR</small>
//               </h6>
//             </button>
//           </span>
//         );
//       } else if (row.isDeleted === 1) {
//         return (
//           <span>
//             {/* <button
//             className="btn btn-info"
//             onClick={(e) => {
//               let deletedAndRestoreModel;

//               deletedAndRestoreModel = {
//                 idProduct: cell,
//                 isDeleted: 0,
//               };

//               //   dispatch(deleteAndRestoreProduct(deletedAndRestoreModel));
//               onDeleteOrRestaureSociete(row.isDeleted, row.id, "allSuplliers");

//               setInfoAlertText("Element restauré avec succée ");
//               setOpenInfoAlert(true);
//               setClients(clients.filter((dept) => dept.id !== cell));
//             }}
//           >
//             <h6>
//               <small>
//                 FOURNISSEUR
//               </small>
//             </h6>
//           </button> */}
//           </span>
//         );
//       }
//     }
//   }
  function buttonUpdateFormatter(cell, row) {
    if (row.isDeleted === 0) {
      return (
        <span>
          <button
            className="btn btn-dark"
            onClick={(e) => {
              localStorage.setItem("SocieteId", row.id);
              navigate("/modifiertiers");
            }}
          >
            <h6>
              <small>
                {" "}
                <i class="fas fa-edit"></i>
              </small>
            </h6>
          </button>
        </span>
      );
    } else if (row.isDeleted === 1) {
      return (
        <button
          className="btn btn-dark"
          disabled
          // onClick={(e) => {
          //   localStorage.setItem("SocieteId", row.id);
          //   navigate("/modifiertiers");
          // }}
        >
          <h6>
            <small>
              {" "}
              <i class="fas fa-edit"></i>
            </small>
          </h6>
        </button>
      );
    }
  }
  function logoFormatter(cell, row) {
    return (
      <span>
        <img
          alt="Remy Sharp"
          src={UtilsUrl.fileRetailURL() + row.fileUrl}
          // ref={(ref) => {
          //   myRefs.current[index] = ref;
          // }}
          class="rounded-circle"
          style={{ width: "50px", height: "50px" }}
        ></img>
      </span>
    );
  }

  const columns = [
    {
      dataField: "id",
      text: "",
      formatter: logoFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },
    {
      dataField: "title",
      text: "Raison social",
      align: "center",
      headerAlign: "center",
    },
    {
      dataField: "matricule",
      text: "Matricule",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "email",
      text: "Email",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "25%" };
      },
    },
    {
      dataField: "numPhone",
      text: "Num",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },
   
    {
      dataField: "id",
      text: "Modifier",
      formatter: buttonUpdateFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "9%" };
      },
    },
    {
      dataField: "id",
      text: "Action",
      formatter: buttonDeleteFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },
  ];

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  function handleTableChange({ products }) {
    return products;
  }
  const pageButtonRenderer = ({
    page,
    active,
    disable,
    title,
    onPageChange,
  }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(page);
    };
    const activeStyle = {};
    if (active) {
      activeStyle.backgroundColor = "black";
      activeStyle.color = "white";
    } else {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    if (typeof page === "string") {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    return (
      <li className="page-item">
        <button
          className="btn btn-dark"
          onClick={handleClick}
          style={activeStyle}
        >
          {page}
        </button>
      </li>
    );
  };
  const options = {
    pageButtonRenderer,
  };

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">{typeClient}</h3>
      </div>
      <div className="card-body">
        <ToolkitProvider
          keyField="id"
          data={clients}
          columns={columns}
          onTableChange={handleTableChange}
          exportCSV
          search
        >
          {(props) => (
            <div>
              <div className="row ml-0">
                <div>
                  <SearchBar
                    {...props.searchProps}
                    className="custome-search-field"
                    style={{ color: "black" }}
                    placeholder="Chercher"
                  ></SearchBar>
                </div>
                <div className="ml-auto mr-0">
                  <MyExportCSV {...props.csvProps}></MyExportCSV>
                </div>
              </div>
              <div className="row">
                <BootstrapTable
                  {...props.baseProps}
                  pagination={paginationFactory(options)}
                  striped
                  hover
                  condensed
                  //   expandRow={expandRow}
                />
              </div>
            </div>
          )}
        </ToolkitProvider>
      </div>

      {openInfoAlert && (
        <Snackbar
          open={openInfoAlert}
          autoHideDuration={2000}
          onClose={handleInfoClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert variant="filled" onClose={handleInfoClose} severity="info">
            {infoAlertText}
          </Alert>
        </Snackbar>
      )}
    </div>
  );
};
export default ClientGroupeSocieteTable;
